import AuthService from 'lib/auth/AuthService';
import { apiClient } from '../../../v4/core/apiClient';
import { myGuestIdentityService } from '../../services/front/GuestIdentityService/GuestIdentityService.connected';
import { createShortlistBoardApi } from './shortlistBoard.api.http';

export const myShortlistBoardApi = createShortlistBoardApi({
  client: apiClient,
  isSignedIn: () => AuthService.isAuthenticated(),
  getGuestId: () => myGuestIdentityService.getGuestId()
});
